<template>
  <div class="broadcast">
    <div>
      <b-dropdown right text="" class="m-md-2 options" :class="optionsVisible ? 'options--visible' : ''">
        <b-dropdown-group header="Theme">
          <b-dropdown-item>
            <theme-picker v-bind:theme.sync="options.theme"></theme-picker>
          </b-dropdown-item>
        </b-dropdown-group>

        <b-dropdown-group header="Border">
          <b-dropdown-item>
            <border-picker v-bind:border.sync="options.border"></border-picker>
          </b-dropdown-item>
        </b-dropdown-group>

        <b-dropdown-group header="Cover">
          <b-dropdown-item>
            <cover-picker v-bind:cover.sync="options.cover"></cover-picker>
          </b-dropdown-item>
        </b-dropdown-group>

        <b-dropdown-group header="Split">
          <b-dropdown-item>
            <split-picker v-bind:split.sync="options.split"></split-picker>
          </b-dropdown-item>
        </b-dropdown-group>
        
        <b-dropdown-header>
          Font
        </b-dropdown-header>

        <b-dropdown-item>
          <font-picker v-bind:fontFamily.sync="options.fontFamily"></font-picker>
        </b-dropdown-item>

        <b-dropdown-item>
          <font-adjuster v-bind:fontSize.sync="options.fontSize"></font-adjuster>
        </b-dropdown-item>

        <b-dropdown-header>
          Effects
        </b-dropdown-header>

        <b-dropdown-item>
          <follow-adjuster v-bind:follow.sync="options.follow"></follow-adjuster>
        </b-dropdown-item>

        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item @click="toggleVisible">
          <span v-if="optionsVisible">Hide Menu</span>
          <span v-else>Show Menu</span>
        </b-dropdown-item>

        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item @click="logOut">Log Out</b-dropdown-item>
      </b-dropdown>
    </div>

    <transition name="fade">
      <div key=1 v-if="$store.state.active && $store.state.keyframe" class="uncovered">
        <transition name="fade">
          <div v-if="$store.state.paused" class="cover" :class="[`cover--${options.cover}`]"></div>
        </transition>

        <Viewer
          :type="$store.state.keyframe.type"
          :id="$store.state.keyframe.id"
          :timestamp="$store.state.keyframe.timestamp"
          :section="$store.state.keyframe.section"
          :position="$store.state.keyframe.position"

          :options="options"
        >
        </Viewer>
      </div>

      <div key=2 v-else class="cover" :class="[`cover--${options.cover}`]"></div>
    </transition>
  </div>
</template>

<script>
  import Viewer from './Viewer';

  import ThemePicker from './ThemePicker.vue';
  import BorderPicker from './BorderPicker.vue';
  import CoverPicker from './CoverPicker.vue';
  import SplitPicker from './SplitPicker.vue';
  import FontAdjuster from './FontAdjuster.vue';
  import FontPicker from './FontPicker.vue';
  import FollowAdjuster from './FollowAdjuster.vue';

  export default {
    props: ['options'],

    components: {
      Viewer,
      FontAdjuster,
      ThemePicker,
      BorderPicker,
      CoverPicker,
      SplitPicker,
      FontPicker,
      FollowAdjuster
    },

    data() {
      return {
        optionsVisible: this.options.optionsVisible
      }
    },

    methods: {
      toggleVisible() {
        this.optionsVisible = !this.optionsVisible
      },

      logOut() {
        this.$store.dispatch('logOut');
        this.$router.push({ name: 'login' })
      }
    }
  };
</script>

<style scoped>
  .broadcast, .cover, .uncovered {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  .cover {
    z-index: 10;
  }

  .cover--default {
    background-image: url('~@/assets/cloud.jpg');
    background-size: cover;
    background-position: center;
  }

  .cover--chroma {
    background: rgb(35, 98, 175);
  }

  .cover--black {
    background: rgb(0, 0, 0);
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s ease-in-out
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0
  }

  .options {
    position: fixed;
    z-index: 1;
    top: 0;
    right: 0;
  
    opacity: 0.25;
    z-index: 1000;
  }

  .options:hover, .options.show {
    opacity: 1;
  }

  /deep/ .options:not(:hover) > button {
    visibility: hidden;
  }

  /deep/ .options.options--visible > button {
    visibility: visible;
  }
</style>